import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-t border-primary/20 bg-surface py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-74" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-75" data-mp="9t1nh6wuedbj">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-primary bg-background p-8 shadow-glow-strong sm:p-12" data-id="element-76" data-mp="etpmaerbbygb">
          <span className="inline-flex rounded-full bg-cta p-4 text-cta-foreground shadow-glow-cta" data-id="element-77" data-mp="smxfubyyf40n">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-78" data-mp="xm1lwtql0lmr" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-4xl font-bold tracking-tight text-foreground" data-id="element-79" data-mp="12kv1crpfimpk">
            7-Day Guarantee
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-80" data-mp="25sgh9c9kk3zt">
            Study all 6 volumes and 5 bonuses in your specific minerals focus area this week. If the technical depth
            doesn't match your professional needs or materials don't enhance your capability,{' '}
            <span className="font-extrabold text-primary" data-id="element-81" data-mp="1rs5qsac68rf6">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}